var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchange-detail detail-padding padding-nav" },
    [
      _c(
        "el-button",
        {
          staticClass: "upper",
          staticStyle: { "margin-bottom": "0.16rem" },
          attrs: { type: "text", icon: "el-icon-d-arrow-left" },
          on: { click: _vm.goback },
        },
        [_vm._v("Go back")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c("div", { staticClass: "spaceLeft" }, [
            _c("div", { staticClass: "detail-title-2" }, [
              _vm._v("Bid No. " + _vm._s(_vm.pageData.number)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "status-title",
                class: {
                  "status-ing": _vm.pageData.status != 3,
                  "status-over": _vm.isOver(_vm.pageData.overtime),
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.statusMap[
                      "status_" +
                        (_vm.isOver(_vm.pageData.overtime)
                          ? "3"
                          : _vm.pageData.status)
                    ]
                  )
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _vm.pageData.status != 3
                ? [
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "detail-item spaceLeft" }, [
                            _c("span", { staticClass: "detail-item-label" }, [
                              _vm._v("Starting time:"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.moment
                                    .utc(_vm.pageData.startTime)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "detail-item spaceLeft" }, [
                            _c("span", { staticClass: "detail-item-label" }, [
                              _vm._v("Closing time:"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.moment
                                    .utc(_vm.pageData.overtime)
                                    .format("YYYY-MM-DD HH:mm:ss")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "detail-item spaceLeft" }, [
                            _c("span", { staticClass: "detail-item-label" }, [
                              _vm._v("Auction:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("big-number", {
                                  attrs: { number: _vm.pageData.amount },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v("UNIT"),
                            ]),
                            _vm._v(" "),
                            _vm.pageData.status == 3
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "status spaceLeft",
                                    class: _vm.getTranfer(_vm.pageData.status)
                                      .class,
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "iconfont",
                                      class: _vm.getTranfer(_vm.pageData.status)
                                        .icon,
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.getTranfer(_vm.pageData.status)
                                            .text
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.pageData.status == 3
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "0.15rem",
                                      color: "#fff",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.moment
                                          .utc(_vm.pageData.timestamp)
                                          .format("YYYY-MM-DD HH:mm:ss")
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "detail-item spaceLeft" }, [
                            _c("span", { staticClass: "detail-item-label" }, [
                              _vm._v("Reserve price:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("big-number", {
                                  attrs: { number: _vm.pageData.startAmount },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v("TCash"),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "detail-item spaceLeft",
                              staticStyle: { margin: "0" },
                            },
                            [
                              _c("place-bid-time", {
                                attrs: {
                                  needHideTips: true,
                                  closeTime: _vm.pageData.overtime,
                                },
                                on: {
                                  "update:closeTime": function ($event) {
                                    return _vm.$set(
                                      _vm.pageData,
                                      "overtime",
                                      $event
                                    )
                                  },
                                  "update:close-time": function ($event) {
                                    return _vm.$set(
                                      _vm.pageData,
                                      "overtime",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "detail-item spaceLeft",
                              staticStyle: { "margin-top": "0.5rem" },
                            },
                            [
                              _c("span", { staticClass: "detail-item-label" }, [
                                _vm._v("My bid price:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                [
                                  _c("big-number", {
                                    attrs: { number: _vm.pageData.myBid },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "unit" }, [
                                _vm._v("TCash"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    "margin-left": "0.24rem",
                                    color: "#2675F1!important",
                                    "font-size": "0.16rem",
                                  },
                                  attrs: { size: "min", type: "text" },
                                  on: { click: _vm.openMyBidDetail },
                                },
                                [
                                  _vm._v("Details "),
                                  _c("i", {
                                    staticClass: "el-icon el-icon-arrow-right",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isOver(_vm.pageData.overtime)
                ? [
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("div", { staticClass: "detail-item spaceLeft" }, [
                          _c("span", { staticClass: "detail-item-label" }, [
                            _vm._v("Starting time:"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.moment
                                  .utc(_vm.pageData.startTime)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("div", { staticClass: "detail-item spaceLeft" }, [
                          _c("span", { staticClass: "detail-item-label" }, [
                            _vm._v("Closing time:"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.moment
                                  .utc(_vm.pageData.overtime)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              )
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("div", { staticClass: "detail-item spaceLeft" }, [
                          _c("span", { staticClass: "detail-item-label" }, [
                            _vm._v("Auction:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("big-number", {
                                attrs: { number: _vm.pageData.amount },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
                          _vm._v(" "),
                          _vm.pageData.status == 3
                            ? _c(
                                "span",
                                {
                                  staticClass: "status spaceLeft",
                                  class: _vm.getTranfer(_vm.pageData.status)
                                    .class,
                                },
                                [
                                  _c("i", {
                                    staticClass: "iconfont",
                                    class: _vm.getTranfer(_vm.pageData.status)
                                      .icon,
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getTranfer(_vm.pageData.status).text
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.pageData.status == 3
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "0.15rem",
                                    color: "#929DAD",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moment
                                        .utc(_vm.pageData.timestamp)
                                        .format("YYYY-MM-DD HH:mm:ss")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c(
                          "div",
                          { staticClass: "detail-item spaceLeft" },
                          [
                            _c("span", { staticClass: "detail-item-label" }, [
                              _vm._v("My bid price:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _c("big-number", {
                                  attrs: { number: _vm.pageData.myBid },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "unit" }, [
                              _vm._v("TCash"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "margin-left": "0.24rem",
                                  color: "#2675F1!important",
                                  "font-size": "0.16rem",
                                },
                                attrs: { size: "min", type: "text" },
                                on: { click: _vm.openMyBidDetail },
                              },
                              [
                                _vm._v("Details "),
                                _c("i", {
                                  staticClass: "el-icon el-icon-arrow-right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticClass: "detail-item spaceLeft" }, [
                        _c("span", { staticClass: "detail-item-label" }, [
                          _vm._v("Reserve price:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c("big-number", {
                              attrs: { number: _vm.pageData.startAmount },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("div", { staticClass: "detail-item spaceLeft" }, [
                          _c("span", { staticClass: "detail-item-label" }, [
                            _vm._v("Winning price:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("big-number", {
                                attrs: { number: _vm.pageData.highValue },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } },
                      [
                        _c("div", { staticClass: "detail-item spaceLeft" }, [
                          _c("span", { staticClass: "detail-item-label" }, [
                            _vm._v("Winning bidder:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "unit" },
                            [
                              _c("account", {
                                attrs: { value: _vm.pageData.winner || "--" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c("div", { staticClass: "detail-title-2" }, [_vm._v("All Bids")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList, "highlight-current-row": "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "data1",
                  label: "",
                  align: "right",
                  width: "50px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var $index = ref.$index
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.queryParams.total -
                                ((_vm.queryParams.page - 1) *
                                  _vm.queryParams.pageSize +
                                  $index)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "account",
                  label: "Bidder",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("account", { attrs: { value: row.account } })]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "Bid Price", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.amount } }),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "timestamp",
                  label: "Bidding Time",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.moment
                                .utc(row.timestamp)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getList()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("detailBidsDialog", { ref: "detailBidsDialog" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.24rem" },
      },
      [
        _c("div", { staticClass: "spaceLeft" }, [
          _c("div", { staticClass: "detail-title-1" }, [_vm._v("Bid details")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }